import { Crown, Star, Plane, type LucideIcon } from 'lucide-react';

export interface PricingPlan {
  id: 'economy' | 'premium_economy' | 'first_class';
  name: string;
  monthlyPrice: string;
  annualPrice: string;
  annualMonthlyEquivalent?: string;
  description: string;
  icon: LucideIcon;
  color: string;
  textColor: string;
  popular: boolean;
  badge?: string;
  features: string[];
}

export const pricingPlans: PricingPlan[] = [
  {
    id: 'economy',
    name: 'Economy Class Pack',
    monthlyPrice: 'Free',
    annualPrice: 'Free',
    description: 'Perfect for occasional travelers',
    icon: Plane,
    color: 'bg-accent',
    textColor: 'text-white',
    popular: false,
    features: [
      'Basic Packing Lists - 3 Daily Uses',
      'Visa Requirements Check - 3 Daily Uses',
      'Jet Lag Minimizer - 3 Daily Uses',
    ],
  },
  {
    id: 'premium_economy',
    name: 'Premium Economy Class Pack',
    monthlyPrice: '€6.99',
    annualPrice: '€69.90',
    annualMonthlyEquivalent: '€5.83',
    description: 'Enhanced travel planning tools',
    icon: Star,
    color: 'bg-primary',
    textColor: 'text-primary-foreground',
    popular: true,
    badge: 'Most Popular',
    features: [
      'Unlimited Searches To All Features',
      'AI-Powered Personalized Lists',
      'Visa Requirements Check',
      'Local Destination Tips',
      'Health & Wellness Preparation',
      'Jet Lag Minimizer',
      'Smart Currency Converter',
      'Group Expense Sharing',
      'Early Access To New Features',
    ],
  },
  {
    id: 'first_class',
    name: 'First Class Pack',
    monthlyPrice: '€11.99',
    annualPrice: '€119.90',
    annualMonthlyEquivalent: '€9.99',
    description: 'Premium experience for frequent travelers',
    icon: Crown,
    color: 'bg-gradient-to-r from-yellow-400 to-yellow-600',
    textColor: 'text-primary-foreground',
    popular: false,
    badge: 'Ultimate Experience',
    features: [
      'Everything In Premium Economy',
      'Offline Mode - Access Lists Without Internet',
      'Multi-City Packing Lists',
      'Custom Travel Templates - Save & Reuse Lists',
      'Advanced Travel Analytics - Spending & Travel Insights',
      'Group Packing Progress Sharing',
    ],
  },
];

const PRODUCT_IMAGE = 'https://odyvoy.com/lovable-uploads/odyvoy-logo.png';

export const pricingStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'OdyVoy Travel Planning',
  description: 'Smart travel planning and packing assistant with AI-powered features',
  image: [PRODUCT_IMAGE],
  brand: { '@type': 'Brand', name: 'OdyVoy' },
  offers: [
    { '@type': 'Offer', name: 'Economy Class Pack', price: '0', priceCurrency: 'EUR', availability: 'https://schema.org/InStock', image: PRODUCT_IMAGE, url: 'https://odyvoy.com/pricing', description: 'Free plan for occasional travelers with basic features' },
    { '@type': 'Offer', name: 'Premium Economy Class Pack', price: '6.99', priceCurrency: 'EUR', priceValidUntil: '2026-12-31', availability: 'https://schema.org/InStock', image: PRODUCT_IMAGE, url: 'https://odyvoy.com/pricing', description: 'Enhanced travel planning tools with AI-powered features' },
    { '@type': 'Offer', name: 'First Class Pack', price: '11.99', priceCurrency: 'EUR', priceValidUntil: '2026-12-31', availability: 'https://schema.org/InStock', image: PRODUCT_IMAGE, url: 'https://odyvoy.com/pricing', description: 'Premium experience for frequent travelers with advanced insights' },
  ],
};
